import React from 'react';
import cn from 'classnames';

import styles from './Table.module.sass';
import { Loader } from 'components/Loader';
import Row from './Row';
import Checkbox from 'components/Checkbox';

// data
import { IEventTicketListItem, IPaginatedResponse } from '@types';
import { Paginate } from 'components/Paginate';

interface TableProps {
  className?: string;
  isRequestLoading: boolean;
  tickets: IPaginatedResponse<IEventTicketListItem> | undefined;
  onApprove: (id: IEventTicketListItem) => void;
  onBulkApprove: (ids: string[]) => void;
  selectedTickets: string[];
  onSelectAll: (checked: boolean) => void;
  onSelectTicket: (ticketId: string, checked: boolean) => void;
  pageCount: number;
  handlePageChange: (selectedItem: { selected: number }) => void;
}

const Table: React.FC<TableProps> = ({
  className,
  tickets,
  isRequestLoading,
  onApprove,
  onBulkApprove,
  selectedTickets,
  onSelectAll,
  onSelectTicket,
  pageCount,
  handlePageChange,
}) => {
  const allTicketIds = tickets?.data?.items.map(ticket => ticket.id) || [];
  const isAllSelected = selectedTickets.length > 0 && selectedTickets.length === allTicketIds.length;
  const isIndeterminate = selectedTickets.length > 0 && selectedTickets.length < allTicketIds.length;

  const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    onSelectAll(checked);
  };

  const handleBulkApprove = () => {
    if (selectedTickets.length > 0) {
      onBulkApprove(selectedTickets);
    }
  };

  return (
    <>
      {isRequestLoading && <Loader />}
      <div className={cn(styles.wrapper, className)}>
        {selectedTickets.length > 0 && (
          <div className={styles.bulkActions}>
            <span>{selectedTickets.length} ტიკეტი არჩეულია</span>
            <button onClick={handleBulkApprove} className={cn('button', 'button-small', 'button-blue')}>
              მონიშნულების გაცემა
            </button>
          </div>
        )}
        <div className={cn(styles.table)}>
          <div className={cn(styles.row, styles.active)}>
            <div className={styles.col}>
              <Checkbox
                value={isAllSelected}
                onChange={handleSelectAll}
                className={isIndeterminate ? styles.indeterminate : ''}
                classCheckboxTick=""
                content=""
                reverse={false}
              />
            </div>
            <div className={styles.col}>სახელი</div>
            <div className={styles.col}>ბილეთების რაოდენობა</div>
            <div className={styles.col}>ბოლო განახლების თარიღი</div>
            <div className={styles.col}>სტატუსი</div>
            <div className={styles.col}></div>
          </div>

          {!isRequestLoading &&
            tickets?.data?.items.map(ticket => (
              <Row
                item={ticket}
                key={ticket.id}
                onApprove={onApprove}
                isSelected={selectedTickets.includes(ticket.id)}
                onSelect={(checked: boolean) => onSelectTicket(ticket.id, checked)}
              />
            ))}
        </div>
        <Paginate pageCount={pageCount} handlePageClick={handlePageChange} />
      </div>
    </>
  );
};

export default Table;
